
// This is an auto generated file - do not edit!
// Swagger path: /api/Activity/{activityid}/case/{caseid}

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';
import {
    Activity
} from '@wdx/clmi/clmi-swagger-gen';

@Injectable({ providedIn: 'root' })
export class ActivityActivityidCaseCaseidApiService extends BaseApiService {
    
    post(activityid: string, caseid: string, activity: any, options = {}): Observable<Activity> {
        return this._post<Activity, any>(
            `/Activity/${activityid}/case/${caseid}`,
            activity,
            options
        );
    }

    delete(activityid: string, caseid: string, options = {}): Observable<Activity> {
        return this._delete<Activity>(
            `/Activity/${activityid}/case/${caseid}`,
            options
        );
    }
}
